import React, { useEffect, useRef, useState } from "react";
import { Flex, Box, Heading, Text } from "rebass";
import { ULink } from "../components/ULink";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export interface ProjectData {
  title: string;
  to?: string | undefined;
  page: string;
  url?: string;
  discipline: string;
  year: string;
  id?: string;
  index?: number;
  label: string | undefined;
  tagline?: string | undefined;
  urlbg?: string | undefined;
  urlcolor? :string | undefined;
}
const ProjectTitle = (props: ProjectData) => {
  const revealTitleRefs = useRef([null]);
  revealTitleRefs.current = [];
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    revealTitleRefs.current.forEach((el) => {
      gsap.fromTo(
        el,
        {
          autoAlpha: 0,
        },
        {
          duration: 0.2,
          autoAlpha: 1,
          ease: "Power4.easeOut",
          scrollTrigger: {
            trigger: el,
            toggleActions: "play none none reverse",
            scrub: 0.5,
          },
        }
      );
    });
  }, []);

  const addTitleToRefs = (el: any) => {
    if (el && !revealTitleRefs.current.includes(el)) {
      revealTitleRefs.current.push(el);
    }
  };
  return (
    <Box
      variant="containerRelatedProject"
      ref={addTitleToRefs}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        borderRadius:"2rem",
        //...(props.urlbg && { backgroundColor: props.urlbg }),
      }}
    >
      <ULink
        {...props}
        to={props.page}
        activeClassName="active"
        partiallyActive={true}
        sx={{
          variant: "links.imgLink",
          display: "block",
          //...(props.urlcolor && { color: props.urlcolor })
        }}
      >
        <Flex flexWrap="wrap" justifyContent="start">
          <Box width={["100%", "100%", "75%"]}>
              <Heading as="h2" variant="bigTitleS" mr={[4]} mb={[2]} pt={[3]}>
                {props.title}
              </Heading>
          </Box>
          <Box width={["100%", "100%", "auto"]} mb={[3]}>
            {props.label ? (
              <Flex my={[1, 2, 3]}>
                <Text as="span" variant="projectLabel" mr={[2]} ml={[0]}>
                  {props.label}
                </Text>
                {props.year ? (
                  <Text as="span" variant="caption" py={[0, 0, 0]}>
                    {props.year}
                  </Text>
                ) : null}
              </Flex>
            ) : null}

            {props.tagline ? (
              <Text as="p" maxWidth="30ch" my={[2, 3]}>
                {props.tagline}
              </Text>
            ) : null}
            {props.discipline ? (
              <Text as="span" variant="caption" py={[0, 0, 0]}>
                {props.discipline}
              </Text>
            ) : null}
          </Box>

          {isHovered && props.url ? (
            <Box
              sx={{
                position: "absolute",
                zIndex: "1",
                top: [2],
                right: "30%",
                maxWidth: "196px",
                p: [3, 4],
                borderRadius: "2rem",
                transform: "rotate(7deg)",
                transition: "all ease-out 0.3",
                ...(props.urlbg && { backgroundColor: props.urlbg }),
              }}
            >
              <img src={props.url} alt={props.title} />
            </Box>
          ) : null}
        </Flex>
      </ULink>
    </Box>
  );
};

export default ProjectTitle;
